export const formatDate = (inputDate) => {
    // Split the input date string into month, day, and year
    var dateParts = inputDate.split('/');
    return dateParts[2] + '-' + dateParts[0] + '-' + dateParts[1];
}

export const formatDateFromSql = (inputDate) => {
    const datePart = inputDate.split('T')[0];
    return datePart
}